import React from 'react';
const Costituzione_fondo_patrimoniale = () => {
    return (
        <>            
            <table cellpadding="3" cellspacing="0">
                <tbody>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2>Elenco documenti Notaio per il Fondo Patrimoniale di persone fisiche</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Carta d’identità o patente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Tesserino del codice fiscale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Estratto per riassunto dell’atto di nascita</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia dell’atto di separazione dei beni</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia dell’atto di precedente fondo patrimoniale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Permesso di soggiorno</td>
                        <td valign="top">Per extracomunitari</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h2>Elenco dcumenti per il Notaio inerenti l’oggetto del fondo patrimoniale</h2>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Rogito o sentenza</td>
                        <td valign="top">Titolo di acquisto</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Dichiarazione di successione</td>
                        <td valign="top">Se l’acquisto è avvenuto per
                        successione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Se si tratta di unità immobiliare</td>
                        <td valign="top">Certificato catastale e planimetria con confini</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato catastale e planimetria con confini</td>
                        <td valign="top">Se si tratta di terreno</td>
                    </tr>
                </tbody>
            </table>
        </>
        );
    }

export default Costituzione_fondo_patrimoniale;